export const russianMonths = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const getDaysInMonth = (year: number, month: number): number =>
  new Date(year, month + 1, 0).getDate();

export const formatDateKey = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

// Типы profit-уровней согласно дизайну Figma
export type ProfitLevel = "negative" | "low" | "medium" | "high" | "none";

// Определяем уровень профита по проценту
export const getProfitLevel = (percent: number | null | undefined): ProfitLevel => {
  if (percent == null || Number.isNaN(percent)) return "none";
  if (percent < 0) return "negative";
  if (percent === 0) return "none";
  if (percent <= 0.6) return "low"; // Изначально было 2%
  if (percent <= 1.2) return "medium"; // Изначально было 5%
  return "high";
};

// Стили ячеек календаря по уровню профита (Tailwind классы)
export const CELL_STYLES: Record<ProfitLevel, { bg: string; text: string }> = {
  negative: {
    bg: "bg-red-500/25",
    text: "text-red-500",
  },
  low: {
    bg: "bg-primary-500/12",
    text: "text-primary-900",
  },
  medium: {
    bg: "bg-primary-500/56",
    text: "text-primary-200",
  },
  high: {
    bg: "bg-primary-500",
    text: "text-primary-900",
  },
  none: {
    bg: "bg-neutral-50/7",
    text: "text-neutral-50/50",
  },
};

// percent — прибыль/убыток в %, например -3.5, 0, 7.2
export const getCellStyles = (
  percent: number | null | undefined
): { bg: string; text: string; level: ProfitLevel } => {
  const level = getProfitLevel(percent);
  const styles = CELL_STYLES[level];

  return {
    bg: styles.bg,
    text: styles.text,
    level,
  };
};
